import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';

export const useWidgetStyles = makeStyles((theme) => ({
    widget: {
        backgroundColor: theme.palette.designSystem.palette.dark1,
        boxShadow: theme.palette.designSystem.palette.boxShadow,
        padding: 10,
        borderRadius: 8,
        height: 105,
        maxWidth: '25vw',
        width: '25vw',
        '&.panel': {
            width: 120,
            height: 80,
        },
    },
    panelWidgetLabel: {
        fontFamily: 'Roboto',
        fontSize: 14,
        fontWeight: 400,
    },
    panelWidgetValue: {
        fontFamily: 'Inter',
        fontSize: 28,
        fontWeight: 600,
        marginTop: 4,
        '&.percent': {
            display: 'inline-flex',
        },
    },
    panelWidgetPercent: {
        display: 'inline-flex',
        color: theme.palette.designSystem.colors.red[700],
        fontFamily: 'Inter',
        fontSize: 18,
        fontWeight: 500,
        marginTop: 4,
        marginLeft: 5,
    },
    gender: {
        // width: 20,
        // height: 20,
        width: 18,
        height: 18,
        right: -45,
        bottom: -7,
        marginLeft: 1,
        marginRight: 8,
        borderRadius: 6,
        display: 'flex',
        color: '#222425',
        alignItems: 'center',
        justifyContent: 'center',

        '&.male': {
            backgroundColor: '#92bfe2',
        },
        '&.female': {
            backgroundColor: '#f4bdd1',
        },
    },
}));

const DoubleValueWidget = ({label1, value1, label2, value2, xs, sx, percentValue}) => {
    const classes = useWidgetStyles();

    return (
        <Grid item
              container
              style={{flexWrap: 'nowrap'}}
              xs={xs}
            // sx={{ ml: 1 , mr: 1 }}

              className={classes.widget}
        >
            <Grid item xs={6}>
                <span className={classes.panelWidgetLabel}>
                    {label1}
                </span>

                <div className={classes.panelWidgetValue} style={{paddingTop: 8}}>
                    {value1}
                </div>
            </Grid>
            <Grid item xs={6}>
                <span className={classes.panelWidgetLabel}>
                    {label2}
                </span>


                {percentValue &&
                    (<div>
                        <div className={clsx(classes.panelWidgetValue, 'percent')}
                             style={{paddingTop: 8}}>{value2}</div>
                        <div className={classes.panelWidgetPercent} style={{paddingTop: 8}}>{percentValue}</div>
                    </div>)
                    ||
                    (
                        <div className={classes.panelWidgetValue} style={{paddingTop: 8}}>
                            {value2}
                        </div>)}
            </Grid>
        </Grid>
    );
};

export default DoubleValueWidget;